export const UPDATE_GENERAL_STORE = "NEW_UPDATE_GENERAL_STORE";
export const SET_DID_OPTIMISTIC_UPDATE = "SET_DID_OPTIMISTIC_UPDATE";
